module.exports = __webpack_public_path__ + "img/leonard-calvert.67633dfc.png";